import { Component, Inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MultiLevelContextMenuItem } from 'src/app/components/api-configurations/common/models/multi-level-context-menu-item';
import { MultiLevelContextMenuComponent } from 'src/app/components/api-configurations/common/multi-level-context-menu/multi-level-context-menu.component';
import { ContextMenuItemEvent } from '../../../../common/models/context-menu-item-event';
import { HeaderElement } from '../Models/header-element';
import { HeaderFormDialogData } from '../Models/header-form-dialog-data';
import { HeaderFormDialogResult } from '../Models/header-form-dialog-result';

@Component({
    selector: 'app-header-form-dialog',
    imports: [MatCardModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, MultiLevelContextMenuComponent],
    templateUrl: './header-form-dialog.component.html',
    styleUrl: './header-form-dialog.component.scss'
})
export class HeaderFormDialogComponent {
    public item: HeaderElement;
    public title: string;

    /**
     * Composant du menu contextuel
     */
    @ViewChild(MultiLevelContextMenuComponent)
    contextMenu: MultiLevelContextMenuComponent;

    /**
     * Liste des éléments du menu contextuel.
     */
    contextMenuItems: MultiLevelContextMenuItem = null;

    /**
     * Index du début du texte sélectionné dans le champ (utilisé pour le placement d'une variable avec le menu contextuel).
     */
    currentSelectionStart: number;

    /**
     * Index de fin du texte sélectionné dans le champ sujet (utilisé pour le placement d'une variable avec le menu contextuel).
     */
    currentSelectionEnd: number;

    /**
     * Position horizontale de la sourris au moment d'un clic droit (utilisé pour positionner le menu contextuel)
     */
    rightClickMenuPositionX: number;

    /**
     * Position verticale de la sourris au moment d'un clic droit (utilisé pour positionner le menu contextuel)
     */
    rightClickMenuPositionY: number;

    /**
     * Valeur indiquant si le menu contextuel est visible.
     */
    isContextMenuVisible: boolean;

    constructor(
        public dialogRef: MatDialogRef<HeaderFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderFormDialogData
    ) {
        this.item = { ...data.item };
        this.title = data.title;
        this.contextMenuItems = data.contextMenuItems;
    }

    onConfirm(): void {
        let result: HeaderFormDialogResult = { status: true, item: this.item };

        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    onCancel(): void {
        let result: HeaderFormDialogResult = { status: false, item: this.item };
        // Close the dialog, return false
        this.dialogRef.close(result);
    }

    /**
     * Levé lorsque l'utilisateur fait un clic-droit sur un champ de saisie.
     * @param source : Identifiant du composant. Permet de déterminer dans quel composant la variable sera ajouté.
     * @param event : Événement souris.
     */
    public onInputRightClick(source: string, event: MouseEvent) {
        this.isContextMenuVisible = true;

        // Position de la souris utilisé pour placer le menu contextuel.
        this.rightClickMenuPositionX = event.clientX;
        this.rightClickMenuPositionY = event.clientY;

        // Récupère la sélection dans le champ Input. Le paramètre remplacera cette selection.
        this.currentSelectionStart = event.target['selectionStart'];
        this.currentSelectionEnd = event.target['selectionEnd'];

        this.contextMenu.openMenu(source, event);
    }

    /**
     * Ferme le menu contextuel.
     */
    public CloseContextMenu() {
        this.isContextMenuVisible = false;
    }

    /**
     * Levé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement clic du menu contextuel.
     */
    public handleMenuItemClick(event: ContextMenuItemEvent) {
        switch (event.source) {
            case 'key':
                if (this.item.key) {
                    this.item.key = this.item.key.substring(0, this.currentSelectionStart) + event.data + this.item.key.substring(this.currentSelectionEnd);
                } else {
                    this.item.key = event.data;
                }

                break;
            case 'value':
                if (this.item.value) {
                    this.item.value = this.item.value.substring(0, this.currentSelectionStart) + event.data + this.item.value.substring(this.currentSelectionEnd);
                } else {
                    this.item.value = event.data;
                }

                break;
        }

        this.isContextMenuVisible = false;
    }
}
